import { useEffect } from "react"
import { createFileRoute } from "@tanstack/react-router"
import DraftPurchaseOrdersTab from "~/components/purchaseOrder/tabs/DraftPurchaseOrdersTab"
import { WorkspacePage } from "~/components/design-system/pages"
import { usePageTracking } from "~/hooks/usePageTracking"
import { useFilters } from "~/hooks/useFilters"
import { PO_BUY_PLAN_FILTER_FIELD, PO_ID_FILTER_FIELD } from "~/components/purchaseOrder/poFilters"

export const Route = createFileRoute("/_auth/procurement/purchase-orders/_layout/draft")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Purchase Orders - Draft")
  const { poIds, purchasePlanId } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { setFilters } = useFilters()

  // Bootstrap: "Create purchase order(s)" and "Finalize Buy" redirect here with a one-shot
  // transport param (new PO ids, or the buy plan's id). Seed the real Filters system with
  // it, then drop the param so a refresh doesn't re-trigger it — from here on it's just a
  // normal, editable filter pill.
  useEffect(() => {
    if (poIds && poIds.length > 0) {
      void setFilters([
        { field: PO_ID_FILTER_FIELD, operator: "oneOf", value: "", by: "", values: poIds },
      ])
      void navigate({ search: (prev) => ({ ...prev, poIds: undefined }) })
    } else if (purchasePlanId != null) {
      void setFilters([
        {
          field: PO_BUY_PLAN_FILTER_FIELD,
          operator: "oneOf",
          value: "",
          by: "",
          values: [String(purchasePlanId)],
        },
      ])
      void navigate({ search: (prev) => ({ ...prev, purchasePlanId: undefined }) })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- one-shot bootstrap on the initial search value only
  }, [poIds, purchasePlanId])

  return (
    <WorkspacePage fillContent contentClassName="p-0">
      <DraftPurchaseOrdersTab />
    </WorkspacePage>
  )
}
